module.exports = __webpack_public_path__ + "img/pr-2.d9d0379c.png";